import cloneDeep from 'lodash/cloneDeep';
import { getLastLineChartMouseX, getLastLineChartMouseY } from '../util';
import {
  OverallStateStage,
  SuccessfulMilkingStage,
  FailedMilkingStage,
  TakeOffReasonObject,
} from '../../../reducers/types/compositeStateTypes';

export const onHoverLineChartPointHandler = (
  d,
  visibleZoomLevelWidthInPx,
  leftVerticalLineOffsetInPixels,
) => {
  const hoveredPoint = cloneDeep(d);
  const hoveredItemXCoordinate =
    getLastLineChartMouseX() - leftVerticalLineOffsetInPixels;
  hoveredPoint.tooltipXCoordinate = hoveredItemXCoordinate;
  hoveredPoint.tooltipYCoordinate = getLastLineChartMouseY();
  return hoveredPoint;
};

export const isMilkingStateSpanSuccesfulOrFailed = (
  stage: OverallStateStage | SuccessfulMilkingStage | FailedMilkingStage,
): stage is SuccessfulMilkingStage | FailedMilkingStage => {
  return stage.name === 'Failed milking' || stage.name === 'Successful milking';
};

export const isTakeOffReasonObject = (
  takeOffReason: string | TakeOffReasonObject,
): takeOffReason is TakeOffReasonObject => {
  return takeOffReason && typeof takeOffReason !== 'string'
    ? 'teat' in takeOffReason
    : false;
};
